module.exports = __webpack_public_path__ + "img/8.565465a1.jpg";